import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

type FilterOutdatedAlertProps = {
  isDataOutdated: boolean;
};

export const DataOutdatedAlert = ({ isDataOutdated }: FilterOutdatedAlertProps) => {
  const { t } = useTranslation();

  if (isDataOutdated) {
    return (
      <Alert severity="warning" sx={{ width: "100%" }}>
        {t("dataOutdatedClickSubmit")}
      </Alert>
    );
  }

  return null;
};
